<template>
    <div class="ModalTransmissao">

        <Modal :showModal="showModal" :size="'lg'" :titulo="'Transmissão Ao Vivo '" :name="'modal-trasnmissao'">
            <template slot="conteudo" v-if="trasmissao != null">
                <template v-if="trasmissao.flPublico == 'Sim' || user != null">
                    <article class="col-12 mt-3" style="border: none;">

                        <div class="videoWrapper embed-responsive embed-responsive-16by9 mb-2">
                            <iframe class="" id="ls_embed_1521030233" :src="trasmissao.urlEmbedVideo" frameborder="0" scrolling="no" allowfullscreen></iframe>
                        </div>
                        <span class="txt-h-4 txt-blue-2">{{trasmissao.nmEvento}}</span>

                    </article>
                </template>
                <template v-else>
                    <div class="row mt-3">
                        <div class="col-md-6">
                            <template v-if="trasmissao.urlImgFoto != null && trasmissao.urlImgFoto != ''">
                                <img :src="trasmissao.urlImgFoto" :alt="trasmissao.nmEvento" class="img-responsive  mb-2" style="max-width: 100%;" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                            </template>
                            <!--<template v-else>
                            <img src="~/Content/img/BannerAoVivo.jpg" class="img-responsive" :alt="trasmissao.nmEvento" style="max-width: 100%;" />
                        </template>-->

                            <span class="txt-h-4 txt-blue-2">{{trasmissao.nmEvento}}</span>
                        </div>
                        <div class="col-md-6">
                            <p class="txt-p txt-grey-2">
                                Cliente Sollicita, faça seu <span class="c-pointer txt-blue-2 txt-w-bold" @click="login">login</span> no portal<br />e assista ao vivo, ou <a :href="urlPlanos" class="c-pointer txt-blue-2 txt-w-bold">cadastre-se</a>  agora.
                            </p>

                        </div>
                    </div>
                </template>
            </template>
        </Modal>

        <ModalLogin :showModal="showModalLogin" :hideModal="hideModalLogin" :logou="logou"></ModalLogin>
    </div>
</template>

<script>
    import Modal from '@/components/Modal';
    import ModalLogin from '@/components/ModalLogin';
    import { urlPlanos } from '@/config/global'

    export default {
        name: 'ModalTransmissao',
        components: { Modal, ModalLogin },
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        data: function () {
            return {
                hideModal: false,
                urlPlanos: urlPlanos,

                showModalLogin: false,
                hideModalLogin: false,
            }
        },
        props: {
            showModal: {
                type: Boolean,
                required: true,
            },
            trasmissao: {
                type: Object,
            },
        },
        methods: {
            
            load() {
                
            },

            login() {
                this.showModalLogin = !this.showModalLogin;
            },

            logou() {
                this.hideModalLogin = !this.hideModalLogin;
                this.$router.push({ name: 'AoVivo' });
            },

        },
        created: function () {
            this.load();
        },
        watch: {
                        
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* ModalTransmissao */
   
</style>

